import { Loader } from '@googlemaps/js-api-loader'
import Logger from '@/services/logger'

export interface LatLng {
  lat: number
  lng: number
}

export class Geocoder {
  private static geocoder: undefined | google.maps.Geocoder
  private async load(): Promise<void> {
    if (Geocoder.geocoder != undefined) {
      return
    }
    const apiKey = process.env.VUE_APP_GOOGLE_API_KEY
    if (apiKey == null) {
      // APIkeyが存在しない場合、エラーとする
      throw new Error('Google API key not setting.')
    }

    const loader = new Loader({
      apiKey: apiKey,
      version: 'weekly',
      channel: '2',
    })
    // googleAPIを読み込む
    const google = await loader.load()
    Geocoder.geocoder = new google.maps.Geocoder()
    Logger.info('Geocoder API Load')
  }

  /**
   * 住所から座標を検索する
   * @param address
   * @returns
   */
  public async search(address: string): Promise<LatLng | null> {
    await this.load()
    // 住所から座標を検索する
    let result: google.maps.GeocoderResponse
    try {
      result = await (Geocoder.geocoder as google.maps.Geocoder).geocode({ address: address })
    } catch (error) {
      return null
    }

    if (result.results != null && result.results.length > 0 && result.results[0].geometry?.location !== undefined) {
      const location = result.results[0].geometry?.location
      // 取得成功
      return {
        lat: location.lat(),
        lng: location.lng(),
      } as LatLng
    } else {
      // 取得失敗
      return null
    }
  }
}
